import { render, staticRenderFns } from "./gmxz.vue?vue&type=template&id=18eebd27&scoped=true&"
import script from "./gmxz.vue?vue&type=script&lang=js&"
export * from "./gmxz.vue?vue&type=script&lang=js&"
import style0 from "./gmxz.vue?vue&type=style&index=0&id=18eebd27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eebd27",
  null
  
)

export default component.exports